import NewEvent from './NewEvent';

export default NewEvent;
